import _ from "lodash";
import { store } from "redux/store";

export const getCurrentPlan = () => {
  const subscriptionData = store?.getState()?.subscription;
  const availablePlans = subscriptionData?.availablePlans;
  const subscription = subscriptionData?.currentSubscription?.subscriptions;
  const currentPlan =
    availablePlans
      ?.find((f) => f?.id === subscription?.[0]?.obj_data?.plan?.product)
      ?.name.toUpperCase() || "TRIAL";
  return currentPlan;
};

export const getPlanStatus = (subscriptions = []) => {
  if (_.isEmpty(subscriptions)) return null;
  const latestSubscription = subscriptions?.reduce((latest, current) => {
    return current?.obj_data?.created > latest?.obj_data?.created
      ? current
      : latest;
  }, subscriptions?.[0]);
  return latestSubscription?.obj_data?.status;
};

export const isSubscriptionExpired = () => {
  const currentPlan = getCurrentPlan();

  if (currentPlan === "TRIAL") return false;

  const isExpired = store?.getState()?.planUsage?.isExpired;

  return isExpired || false;
};

export const activeStatus = ["trialing", "past_due", "active", "paused"];
